export const EmailNotificationsPreferencesQueryKey =
  "email-notifications-preferences";

export const PushNotificationsPreferencesQueryKey =
  "push-notifications-preferences";
